import Axios from 'axios';

export default {

  // 问卷列表
  list() {
    return Axios.get('/wjdc/api/admin/list');
  },

  // 问卷推送
  push(
    id,
  ) {
    return Axios.put(`/wjdc/api/admin/${id}/status`);
  },

  // 问卷上线下线切换
  switchStatus(
    id
  ) {
    return Axios.put(`/wjdc/api/admin/${id}/show`);
  },

  // 删除问卷
  del(
    ids
  ) {
    return Axios.delete('/wjdc/api/admin/', {
      data: {
        ids
      }
    });
  },

  //新增问卷
  add(
    title,
    start_time,
    ended_at,
    banner,
    community_ids,
    status,
    score,
    description,
    desc,
    questions
  ) {
    return Axios.post('/wjdc/api/admin/', {
      title,
      start_time,
      ended_at,
      banner,
      community_ids,
      status,
      score,
      description,
      desc,
      questions
    });
  },

  //问卷编辑
  edit(
    id,
    title,
    start_time,
    ended_at,
    banner,
    community_ids,
    status,
    score,
    description,
    desc,
    questions
  ) {
    return Axios.put(`/wjdc/api/admin/${id}`, {
      id,
      title,
      start_time,
      ended_at,
      banner,
      community_ids,
      status,
      score,
      description,
      desc,
      questions
    });
  },

  //问卷详情
  info(
    id
  ) {
    return Axios.get(`/wjdc/api/admin/${id}`, {
      params: {
        include: 'questions'
      }
    });
  },

  // 列表ids
  listIds(
    id
  ) {
    return Axios.get(`/wjdc/api/admin/${id}/platform`);
  },

  // 回收数据分页列表
  recoverDataListPage(
    id,
    name,
    page,
    per_page
  ) {
    return Axios.get(`/wjdc/api/admin/${id}/answer`, {
      params: {
        name,
        page,
        per_page
      }
    });
  },

  // 数据统计列表
  statisticsList(
    id
  ) {
    return Axios.get(`/wjdc/api/admin/${id}/statistical`);
  }


}